import type { JSX } from 'react'

export const MasterCardIcon = (): JSX.Element => (
  <use href='#masterCard' height='100%' width='100%' />
)
